import React, { Component } from 'react';
import { PrivateRoute } from '../PrivateRoute';
import Dashboard from './dashboard';
import Users from './users';
import Applications from './applications';
import ApplicationInfo from './applications/applicationInfo/ApplicationInfo';
import './Layouts.scss';

class Layouts extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div
        className="layouts"
        style={{
          transition: 'all .2s ease-in-out',
          marginLeft: this.props && this.props.toggle ? '0' : '',
        }}
      >
        <PrivateRoute path="/admin" exact component={Dashboard} />
        <PrivateRoute
          path="/admin/applications/:id"
          component={ApplicationInfo}
        />
        <PrivateRoute
          exact
          path="/admin/applications"
          component={Applications}
        />
        <PrivateRoute path="/admin/users" component={Users} />
      </div>
    );
  }
}

export default Layouts;
